<app-header></app-header>
<div class="container">
  <div class="breadcrumbs mt-4">
    <div routerLink="/">Главная</div>
    <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
    <path d="M9 18L15 12L9 6" stroke="black" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"/>
  </svg>
    <div routerLink="/otzyvy">Отзывы</div>

  </div>
  <div class="row">
    <h1 class="w-100 mt-70">{{currItem?.title}}
    </h1>
    <img *ngIf="currItem" class="mt-5" [src]="currItem.scan" alt="" style="width: 100%">
  </div>
</div>
<app-footer></app-footer>
